import { api } from '../../../lib/api'

export const ADD_PRODUCT_DATA_REQUEST = 'ADD_PRODUCT_DATA_REQUEST'
export const ADD_PRODUCT_DATA_SUCCESS = 'ADD_PRODUCT_DATA_SUCCESS'
export const ADD_PRODUCT_DATA_FAILED = 'ADD_PRODUCT_DATA_FAILED'

export const CLEAR_ADD_PRODUCT = 'CLEAR_ADD_PRODUCT'

export const ADD_FURNITURE_TEXTURES_SUCCESS = 'ADD_FURNITURE_TEXTURES_SUCCESS'
export const ADD_FURNITURE_TEXTURES_FAILED = 'ADD_FURNITURE_TEXTURES_FAILED'

export const addProductData = function (productData, productId) {
  return function (dispatch) {

    dispatch({
      type: ADD_PRODUCT_DATA_REQUEST
    })

    return api.addProductData(productData, productId).then(addProductDataResponse => {
      dispatch({
        type: ADD_PRODUCT_DATA_SUCCESS,
        payload: addProductDataResponse
      })
    }).catch(error => {
      dispatch({
        type: ADD_PRODUCT_DATA_FAILED,
        error
      })
    })
  }
}


export const clearFurnitureAddProduct = function () {
  return function (dispatch) {
    dispatch({
      type: CLEAR_ADD_PRODUCT
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/product/add-furniture-product-data.js